<app-header></app-header>

<div class="welcome-info-block">
	<h1 class="welcome-name">{{ fullName() }}</h1>
	<p class="welcome-email">{{ email() }}</p>
</div>

<div class="form-page-wrapper mb-5">
	<h2 class="mt-3">Dati personali</h2>
	<div class="form-box">
		<div class="form-group">
			<label class="form-label-kf-dati-personali">Nome</label>
			<input type="text" class="form-control-kf-dati-personali" [ngModel]="utenteSignal().nome" [disabled]="true" />
		</div>
		<div class="form-group">
			<label class="form-label-kf-dati-personali">Cognome</label>
			<input type="text" class="form-control-kf-dati-personali" [ngModel]="utenteSignal().cognome" [disabled]="true" />
		</div>
		<div class="form-group">
			<label class="form-label-kf-dati-personali">Email</label>
			<input type="email" class="form-control-kf-dati-personali" [ngModel]="utenteSignal().user" [disabled]="true" />
		</div>
		<div class="form-group">
			<label class="form-label-kf-dati-personali">Cellulare</label>
			<input type="text" class="form-control-kf-dati-personali" [ngModel]="utenteSignal().cellulare" (ngModelChange)="utenteSignal().cellulare = $event" />
		</div>
	</div>

	<h2 class="mt-3">Dati Firma Remota</h2>
	<div class="form-box">
		<div class="form-group">
			<label class="form-label-kf-dati-personali">Utente Firma Remota</label>
			<input type="text" class="form-control-kf-dati-personali" [ngModel]="utenteSignal().swsUser" [disabled]="true" />
		</div>
		<div class="form-group">
			<label class="form-label-kf-dati-personali">ID Disposito OTP</label>
			<input type="text" class="form-control-kf-dati-personali" [ngModel]="utenteSignal().swsId" (ngModelChange)="utenteSignal().swsId = $event" />
		</div>
	</div>

	@if (success()) {
		<div class="mt-3" style="background:#E9F7EF; border-radius:12px; padding:14px; margin-bottom:16px; display:flex; gap:10px; align-items:center;">
			<i class="bi bi-check-circle-fill" style="color:#039855;"></i>
			<span style="font-size:14px;">Dati salvati con successo.</span>
		</div>
	}

	<button class="mt-3 btn-kf-primary" (click)="salva()" [disabled]="loading()">
		@if (loading()) {
			<span class="spinner-border spinner-border-sm me-2"></span>
		}
		SALVA
	</button>

	<div class="text-center mt-3 mb-5 pb-5 link-cancel" (click)="goBack()">Torna indietro</div>
</div>
